// extracted by mini-css-extract-plugin
module.exports = {"Tooltip":"Tooltip_Tooltip__r1oe4","tooltip-pop-in":"Tooltip_tooltip-pop-in__B69qB"};